import React from 'react';
import SkillBadge from './SkillBadge';
import { SkillThreshold } from 'types';

interface Props {
	requiredSkills: SkillThreshold[];
}

const RecruiterPositionCardRequiredSkills = ({ requiredSkills }: Props) => {
	const showTruncatedText = requiredSkills.length > 2;
	const maxLength = 2;
	const plusText = requiredSkills.length - maxLength;

	return (
		<>
			<div className="text-[10px] leading-[16px] text-[#7777E7] font-[400] dark:text-[#CCDDFF]">Required Skills</div>
			{requiredSkills.length ? (
				<div className="flex flex-wrap gap-2 mt-1">
					{requiredSkills.map((s, i) => {
						if (i < maxLength) {
							return <SkillBadge key={s.displaySkill} content={<>{s.displaySkill}</>} />;
						}
						return null;
					})}

					{showTruncatedText ? <SkillBadge content={<>+ {plusText} more</>} /> : null}
				</div>
			) : (
				<div className="text-[10px] mt-1 text-[#7777E7] dark:text-[#CCDDFF] italic">*No skills required</div>
			)}
		</>
	);
};

export default RecruiterPositionCardRequiredSkills;
